export { FullScreenIcon } from './full-screen'
